import { render, staticRenderFns } from "./RightClickMenu.vue?vue&type=template&id=05ed388c&scoped=true&"
import script from "./RightClickMenu.vue?vue&type=script&lang=js&"
export * from "./RightClickMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed388c",
  null
  
)

export default component.exports